import { NodeItemType } from '../enums/node-item-type';

export class FlatNodeItem {
  public item: string;
  public level: number;
  public expandable: boolean;  // true if node has childrens
  public type: NodeItemType;
  public selected: boolean;
  public alias: string;
  public max?: number;
}
